// extracted by mini-css-extract-plugin
export default {"auth":"styles_auth__5bkn6","auth_form":"styles_auth_form__6Z1OG","input":"styles_input__FNkWF","btn":"styles_btn__LAMJ0"};